import {
  AdminInput,
  Button,
  Div,
  ErrorToast,
  Modal,
  PropsModal,
  Tab,
  SuccessToast,
  getLocationTrackingSms,
  reportError,
  sendLocationTrackingSms,
} from '@vgrubs/components';
import {
  LocationTrackingSmsEntity,
  TrackingSmsType,
} from 'components/src/types/api/location.types';
import { useEffect, useState } from 'react';
import { TrackingSmsHistoryModal } from './TrackingSmsHistoryModal';

const isValidLink = (url: string) => {
  try {
    const { hostname } = new URL(
      /^https?:\/\//i.test(url) ? url : `https://${url}`
    );
    // Require a real domain with a label and a TLD, e.g. "google.com"
    // (rejects bare TLDs like ".com" or single words like "google")
    return /^([a-z0-9](-*[a-z0-9])*\.)+[a-z]{2,}$/i.test(hostname);
  } catch {
    return false;
  }
};

export const SendTrackingSmsModal = ({
  modalIsOpen,
  closeModal,
  setLoading,
  locationId,
}: PropsModal & {
  modalIsOpen: boolean;
  locationId: string | number;
}) => {
  const [trackingLink, setTrackingLink] = useState('');
  const [type, setType] = useState<TrackingSmsType>('tablet');
  const [historyModal, setHistoryModal] = useState(false);
  const [history, setHistory] = useState<LocationTrackingSmsEntity[]>([]);

  useEffect(() => {
    if (modalIsOpen) {
      setTrackingLink('');
      setType('tablet');
    }
  }, [modalIsOpen]);

  async function handleSend() {
    const link = trackingLink.trim();

    if (!link) {
      ErrorToast('Please enter a shipment link.');
      return;
    }

    if (!isValidLink(link)) {
      ErrorToast('Please enter a valid link.');
      return;
    }

    try {
      setLoading?.(true);
      const res = await sendLocationTrackingSms(locationId, {
        trackingLink: link,
        type,
      });
      SuccessToast(res.data.message);
      closeModal?.();
    } catch (error) {
      reportError(error);
    } finally {
      setLoading?.(false);
    }
  }

  async function handleViewHistory() {
    try {
      setLoading?.(true);
      const { data } = await getLocationTrackingSms(locationId);
      setHistory(data.data);
      setHistoryModal(true);
    } catch (error) {
      reportError(error);
    } finally {
      setLoading?.(false);
    }
  }

  return (
    <>
      <Modal
        isOpen={modalIsOpen && !historyModal}
        closeModal={closeModal}
        logo={false}
        header="Send Shipment Link"
      >
        <AdminInput
          placeholder="Enter here..."
          value={trackingLink}
          onChange={(e) => setTrackingLink(e.target.value)}
          $textCenter
          label="Shipment Link"
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
        />

        <Div $flex $gap="16px" $mt="24">
          <Tab
            $width="calc(50% - 8px)"
            $minWidthAuto
            selected={type === 'tablet'}
            onClick={() => setType('tablet')}
          >
            Tablet
          </Tab>
          <Tab
            $width="calc(50% - 8px)"
            $minWidthAuto
            selected={type === 'printer'}
            onClick={() => setType('printer')}
          >
            Printer
          </Tab>
        </Div>

        <Button $selected $w="100%" $mt="40" onClick={handleSend}>
          Send
        </Button>

        <Button $w="100%" $mt="16" onClick={handleViewHistory}>
          View SMS History
        </Button>
      </Modal>
      <TrackingSmsHistoryModal
        modalIsOpen={historyModal}
        closeModal={() => setHistoryModal(false)}
        history={history}
      />
    </>
  );
};
